<div class="popup modal-header d-inline-block pb-0 w-100 m-auto">
  <div class="p-4">
    <div class="d-flex justify-content-end">
      <fa-icon [icon]="icons.close" (click)="close()" class="icon"></fa-icon>
    </div>

    <h4 class="fw-bold mb-2">Remove Document</h4>
    <p class="text-muted mb-4">Are you sure you want to remove this <br><strong class="text-dark">Document?</strong></p>

    <div class="d-flex gap-3">
      <button class="btn btn-cancel flex-fill" (click)="close()">No, Cancel</button>
      <button class="btn btn-remove flex-fill" [disabled]="submitting" (click)="confirm()">
        {{ submitting ? 'Removing...' : 'Yes, Remove' }}
      </button>
    </div>
  </div>
</div>
